import { FC } from 'react';
import styles from './scroller.module.scss';
import { ScrollerProps } from './scrollerTypes';
import SelectItem from '../selectItem/selectItem';

const Scroller: FC<ScrollerProps> = (props: ScrollerProps) => {
    const { items, height, onChange, selectedItems, isOverlay, maxHeight } = props;

    return (
        <div
            data-testid="scroller"
            className={styles.scroller}
            style={{
                height: height ? `${height}rem` : 'max-content',
                position: isOverlay ? 'absolute' : 'relative',
                maxHeight
            }}
        >
            {items.map((item, index) => {
                return (
                    <SelectItem
                        key={index}
                        name={item.name}
                        displayName={item.displayName}
                        isSelected={selectedItems.includes(item.name)}
                        onChange={onChange}
                    />
                );
            })}
        </div>
    );
};

export default Scroller;
